import { useAppDispatch } from '../../../../lib/store';
import {
  AddedConcept,
  removeConcept,
  clearConceptInEditMode,
} from '../../state/createProjectSlice';

interface UseEditConceptGroupAndAttrCardProps {
  concept: AddedConcept;
}

interface UseEditConceptGroupAndAttrCardResults {
  removeAddedConcept: () => void;
  closeEditMode: () => void;
  doneButtonDisabled: boolean;
}
export const useEditConceptGroupAndAttrCard = ({
  concept,
}: UseEditConceptGroupAndAttrCardProps): UseEditConceptGroupAndAttrCardResults => {
  const dispatch = useAppDispatch();

  const removeAddedConcept = () => {
    dispatch(removeConcept(concept.conceptCardId));
  };

  const closeEditMode = () => {
    dispatch(clearConceptInEditMode());
  };
  const doneButtonDisabled = concept.conceptGroupName.trim() === '';
  return {
    removeAddedConcept,
    closeEditMode,
    doneButtonDisabled,
  };
};
